<template>
  <ProjectsManager />
</template>

<script setup>
import ProjectsManager from '@/sections/manager/projects/ProjectsManager.vue';
</script>
